import ErrorPopup from '@/components/ErrorPopup/ErrorPopup';
import i18n from './i18n';

export default {
  install(Vue) {
    const popup = new Vue({
      i18n,
      render(h) {
        return h(ErrorPopup, {
          props: this.$data,
          on: {
            click: this.handleClick,
          },
        });
      },
      data() {
        return {
          isVisible: false,
          message: null,
        };
      },
      methods: {
        handleClick() {
          this.hideError();
        },
        hideError() {
          this.isVisible = false;
        },
        showError(message) {
          this.isVisible = true;
          this.message = message;
          this.$forceUpdate();
        },
      },
    }).$mount('#error-popup');

    Vue.prototype.$showError = message => {
      popup.showError(message);
    };

    Vue.prototype.$hideError = () => {
      popup.hideError();
    };
  },
};
